import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authAPI, fmtError, tokenStore } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      if (!tokenStore.get()) { setUser(null); setLoading(false); return; }
      const me = await authAPI.me();
      setUser(me);
    } catch {
      tokenStore.clear();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    try {
      const res = await authAPI.login({ email, password });
      if (res.access_token) tokenStore.set(res.access_token);
      setUser(res.user);
      return { ok: true };
    } catch (e) { return { ok: false, error: fmtError(e) }; }
  };

  const register = async (body) => {
    try {
      const res = await authAPI.register(body);
      if (res.access_token) tokenStore.set(res.access_token);
      setUser(res.user);
      return { ok: true };
    } catch (e) { return { ok: false, error: fmtError(e) }; }
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {}
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
